import { render, staticRenderFns } from "./TSZ_Presupuesto.vue?vue&type=template&id=1a0c3688&scoped=true&"
import script from "./TSZ_Presupuesto.vue?vue&type=script&lang=js&"
export * from "./TSZ_Presupuesto.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Presupuesto.vue?vue&type=style&index=0&id=1a0c3688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c3688",
  null
  
)

export default component.exports